export const GET_FACEBOOK = 'GET_FACEBOOK';
export const GET_FACEBOOK_IMAGE = 'GET_FACEBOOK_IMAGE';
export const GET_TWITTER = 'GET_TWITTER';
export const API_HOST = 'https://webtools.au.dk';
